import { ReactNode } from 'react';
import { TrendingUp, TrendingDown, Minus } from 'lucide-react';

interface KPICardProps {
  title: string;
  value: string | number;
  subtitle?: string;
  icon: ReactNode;
  trend?: 'up' | 'down' | 'neutral';
  trendValue?: string;
  colorClass?: string;
  loading?: boolean;
}

export default function KPICard({
  title,
  value,
  subtitle,
  icon,
  trend,
  trendValue,
  colorClass = 'text-electric-blue',
  loading = false,
}: KPICardProps) {
  return (
    <div className="bg-card border border-border rounded-lg p-5 shadow-card-dark relative overflow-hidden group hover:border-electric-blue/30 transition-colors">
      {/* Background accent */}
      <div className="absolute top-0 right-0 w-24 h-24 opacity-5 rounded-bl-full"
        style={{ background: 'oklch(0.72 0.18 220)' }} />

      <div className="flex items-start justify-between mb-3">
        <p className="text-xs font-semibold uppercase tracking-widest text-muted-foreground">{title}</p>
        <div className={`${colorClass} opacity-70`}>{icon}</div>
      </div>

      {loading ? (
        <div className="space-y-2">
          <div className="h-8 w-24 bg-muted/50 rounded animate-pulse" />
          <div className="h-3 w-16 bg-muted/30 rounded animate-pulse" />
        </div>
      ) : (
        <>
          <p className={`text-3xl font-black tracking-tight ${colorClass} mb-1`}>{value}</p>
          {subtitle && (
            <p className="text-xs text-muted-foreground">{subtitle}</p>
          )}
          {trend && trendValue && (
            <div className={`flex items-center gap-1 mt-2 text-xs font-medium ${
              trend === 'up' ? 'text-status-success' :
              trend === 'down' ? 'text-status-danger' :
              'text-muted-foreground'
            }`}>
              {trend === 'up' ? <TrendingUp className="w-3 h-3" /> :
               trend === 'down' ? <TrendingDown className="w-3 h-3" /> :
               <Minus className="w-3 h-3" />}
              <span>{trendValue}</span>
            </div>
          )}
        </>
      )}
    </div>
  );
}
